import { B2BLink } from "../link/b2blink";
import { FileUpload, FileUploadHandlerEvent } from "primereact/fileupload";
import { useEffect, useRef } from "react";
import { useUploadImageMutation } from "../../redux/survey/survey.endpoints";
import { BulkSurvey } from "../../services/admin/survey/survey.types";

interface BulkSurveyCreationResultProps {
  readonly survey: BulkSurvey;
}

const BulkSurveyCreationResult = ({ survey }: BulkSurveyCreationResultProps) => {
  const fileUploadRef = useRef<FileUpload | null>(null);
  const [uploadImage, { isSuccess: imageUploadSuccess, isError: imageUploadError }] = useUploadImageMutation();

  useEffect(() => {
    imageUploadError && fileUploadRef.current && fileUploadRef.current.clear();
  }, [imageUploadError]);

  async function updateSurveyImage(event: FileUploadHandlerEvent, extSurveyId: string): Promise<void> {
    const file = event.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'survey');
    formData.append('uuid', extSurveyId);

    void uploadImage({ formData: formData, uuid: extSurveyId });
  }

  return (
    <div
      className="flex flex-col m-2"
    >
      <B2BLink
        className='text-lg'
        label={survey.title + ' - ' + survey.ext_survey_id}
        link={`/admin/surveys/${survey.ext_survey_id}`}
      />
      <div>
        <FileUpload
          className='bg-white'
          headerClassName='bg-white'
          ref={fileUploadRef}
          accept="image/*"
          auto
          chooseLabel="Upload Image"
          customUpload
          uploadHandler={(event) => updateSurveyImage(event, survey.ext_survey_id)}
        />
        {imageUploadSuccess && (
          <div className='text-green-401'>
            Image uploaded successfully
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkSurveyCreationResult;
